module.exports = __webpack_public_path__ + "img/ico-export.3d148e2c.svg";